import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { FileService } from 'projects/forms/src/app/infrastructure/services/file.service';

@Component({
  selector: 'app-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss'],
})
export class ModalHeaderComponent implements OnDestroy {
  imgPreview: string = '';
  isDragActive = false;
  isUploading = false;
  uploadError: string = '';
  unsubscribe$ = new Subject();

  constructor(
    public dialogRef: MatDialogRef<ModalHeaderComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { data: string; formId: string; versionId: string },
    private fileService: FileService
  ) {
    this.imgPreview = data.data;
  }

  closeModal(close: boolean) {
    this.dialogRef.close({ close, header: this.imgPreview });
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragActive = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragActive = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragActive = false;
    const file = event.dataTransfer?.files[0];
    if (file && file.type.startsWith('image/')) {
      this.uploadFile(file);
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (file) {
      this.uploadFile(file);
    }
    input.value = '';
  }

  private uploadFile(file: File) {
    this.isUploading = true;
    this.uploadError = '';

    this.fileService
      .uploadImage(this.data.formId, this.data.versionId, 'header', file)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (downloadUrl) => {
          this.imgPreview = downloadUrl;
          this.isUploading = false;
        },
        error: (err) => {
          this.isUploading = false;
          this.uploadError = 'Error uploading image. Please try again.';
          console.error(err);
        },
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
